<template>
	<div class="d-flex gap-1">
		<select class="form-select form-select-sm w-auto" v-model="metodo" @change="cambiaMetodo">
			<option value="">Metodo</option>
			<option v-for="m in metodi" :key="m.ID" :value="m.ID">{{ m.DESCRIZIONE }}</option>
		</select>
		<select class="form-select form-select-sm flex-fill" :value="modelValue" @change="$emit('update:modelValue', $event.target.value)" :disabled="metodo == ''">
			<option value="">Conto</option>
			<option v-for="conto in conti" :key="conto.ID_OPZIONE_TIPOLOGICA" :value="conto.ID_OPZIONE_TIPOLOGICA">{{ conto.CUSTOM_1 }}</option>
		</select>
	</div>
</template>

<script>
// Il metodo di versamento sta in CUSTOM_2 dei conti (tipologica BANCHE)
export default {
	name: 'SelectConto',
	props: {
		modelValue: { type: [Number, String], default: '' }
	},
	emits: ['update:modelValue'],
	data() {
		return {
			metodo: '',
			metodi: [{ ID: 1, DESCRIZIONE: 'Contanti' }, { ID: 2, DESCRIZIONE: 'Carta' }, { ID: 3, DESCRIZIONE: 'Assegno' }, { ID: 4, DESCRIZIONE: 'Banca' }]
		};
	},
	computed: {
		conti() { return this.$root.arrayConti.filter(c => c.CUSTOM_1 && c.CUSTOM_2 == this.metodo); }
	},
	watch: {
		modelValue: {
			immediate: true,
			handler(id) {
				const conto = this.$root.arrayConti.find(c => c.ID_OPZIONE_TIPOLOGICA == id);
				if (conto) this.metodo = parseInt(conto.CUSTOM_2) || '';
			}
		}
	},
	methods: {
		cambiaMetodo() {
			this.$emit('update:modelValue', this.conti.length == 1 ? this.conti[0].ID_OPZIONE_TIPOLOGICA : '');
		}
	}
}
</script>
